import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export const isStreetValid: ValidatorFn = (control: UntypedFormGroup): {[key: string]: any} | null => {
  const reg = new RegExp(/^(.{3,45})\s(\d{1,3}[a-zA-Z]?)$/);
  if (control.value != null && !reg.test(control.value)) {
    return { streetInvalid: true };
  }

  return null;
};
